import * as React from 'react';

import { OpenArrowButton } from '../../active-button';
import { DropdownList } from './dropdown-list';
import { getValue } from './input-utils';
import { SearchItems } from './search-items';
import { Styled } from './styled';

export const SearchItemsWithDropdownList = (props) => {
  const {
    isDropdownOpen,
    onOpenDropdown,
    innerSideRef,
    onChangeValue,
    activeElement,
    onInputBlur,
    onClickArrowContainer,
    elements,
    filteredElements,
    maxItemsAmount = 5,
    onClickDropDownTextItem,
    isShowNewValue,
    inputValue,
    optionRenderer,
    selectedOptionRenderer,
  } = props;

  const selectedElementInfo = React.useMemo(
    () => elements.find((element) => getValue(element) === activeElement),
    [elements, activeElement],
  );

  return (
    <Styled.DropDownContainer
      isDropdownOpen={isDropdownOpen}
      onClick={onOpenDropdown}
      ref={innerSideRef}
      onBlur={onInputBlur}
    >
      <Styled.SelectedContent isOpen={isDropdownOpen}>
        <SearchItems
          isDropdownOpen={isDropdownOpen}
          onChangeValue={onChangeValue}
          activeElement={selectedElementInfo || activeElement}
          value={inputValue}
          selectedOptionRenderer={selectedOptionRenderer || optionRenderer}
        />
        <OpenArrowButton
          isOpen={isDropdownOpen}
          onClick={onClickArrowContainer}
        />
      </Styled.SelectedContent>
      {isDropdownOpen && (
        <DropdownList
          elements={elements}
          filteredElements={filteredElements}
          activeElement={activeElement}
          maxItemsAmount={maxItemsAmount}
          onClick={onClickDropDownTextItem}
          isShowNewValue={isShowNewValue}
          optionRenderer={optionRenderer}
        />
      )}
    </Styled.DropDownContainer>
  );
};
